import { render, staticRenderFns } from "./TeamRoleDetails.vue?vue&type=template&id=43f4247d&scoped=true"
import script from "./TeamRoleDetails.vue?vue&type=script&lang=js"
export * from "./TeamRoleDetails.vue?vue&type=script&lang=js"
import style0 from "./TeamRoleDetails.vue?vue&type=style&index=0&id=43f4247d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f4247d",
  null
  
)

export default component.exports